export default __webpack_public_path__ + "static/16-156e1597b378086e503807a11ba31fe1.jpg";